import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/invoicePurchaser/page', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/v4ward/invoicePurchaser/remove', qs.stringify(params),options);

export const getPurchaserList = (params, options) =>
  request.get('/api/v4ward/invoicePurchaser/selectPurchaserList', Object.assign({}, options, { params }));
